import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface KeywordModalState {
  isOpen: boolean;
  modalKey?: string;
}

const initialState: KeywordModalState = {
  isOpen: false,
  modalKey: undefined,
};

const keywordModalSlice = createSlice({
  name: "keywordModal",
  initialState,
  reducers: {
    openKeywordModal: (state) => {
      state.isOpen = true;
    },
    closeKeywordModal: (state) => {
      state.isOpen = false;
    },
    setKeywordModal: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },
    setKeywordModalKey: (state, action: PayloadAction<string | undefined>) => {
      state.modalKey = action.payload;
    },
  },
});

export const { openKeywordModal, closeKeywordModal, setKeywordModal, setKeywordModalKey } = keywordModalSlice.actions;
export default keywordModalSlice.reducer;
